var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgErrorWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5 99.75H108.5C112.366 99.75 115.5 96.616 115.5 92.75V88.5H55.5V99.75ZM55.5 86.25H115.5V75.75H55.5V86.25ZM53.25 75.75V86.25H30.75L30.75 75.75H53.25ZM55.5 73.5H115.5V62.25H55.5V73.5ZM53.25 62.25V73.5H30.75V62.25H53.25ZM55.5 60H115.5V49.5H55.5L55.5 60ZM53.25 49.5L53.25 60H30.75V49.5H53.25ZM55.5 47.25H115.5V36.75H55.5V47.25ZM53.25 36.75V47.25H30.75V36.75H53.25ZM55.5 34.5H115.5V27.25C115.5 23.384 112.366 20.25 108.5 20.25H55.5V34.5ZM53.25 20.25V34.5H30.75L30.75 20.25H53.25ZM53.25 88.5V99.75H30.75V88.5H53.25ZM28.5 75.75L28.5 86.25H4.5V75.75H28.5ZM28.5 49.5V60H4.5V49.5H28.5ZM4.5 73.5V62.25H28.5V73.5H4.5ZM28.5 34.5L28.5 20.25H11.5C7.63401 20.25 4.5 23.384 4.5 27.25V34.5H28.5ZM4.5 36.75V47.25H28.5V36.75H4.5ZM28.5 88.5V99.75H11.5C7.63401 99.75 4.5 96.616 4.5 92.75V88.5H28.5Z",
    fill: "#E4EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 27.25C6.5 24.4886 8.73858 22.25 11.5 22.25H108.5C111.261 22.25 113.5 24.4886 113.5 27.25V32.5H6.5V27.25Z",
    fill: "#C6DAFF",
    stroke: "#C6DAFF",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 49.5H28.5V60H4.5V49.5Z",
    fill: "#C6DAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 49.5H53.25V60H30.75V49.5Z",
    fill: "#C6DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 49.5H115.5V60H55.5V49.5Z",
    fill: "#C6DAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgErrorWait);
export default __webpack_public_path__ + "static/media/img_error_wait.b9fc49ec7bb0e40e7a07cda1004702ea.svg";
export { ForwardRef as ReactComponent };